import { Api } from '../lib/api/api';
import { toast } from 'react-toastify';

export const proposalEditorFieldUpdate = (name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_EDITOR_FIELD_UPDATE',
    name,
    value,
  });
};

export const initializeProposalEditor = proposalData => dispatch => {
  dispatch({
    type: 'INITIALIZE_PROPOSAL_EDITOR',
    proposal: proposalData,
  });
};

export const initializeProposalObject = proposalData => dispatch => {
  dispatch({
    type: 'INITIALIZE_PROPOSAL_OBJECT',
    proposal: proposalData,
  });
};

// Proposal Boxes
export const clearProposalLocations = () => dispatch => {
  dispatch({
    type: 'CLEAR_PROPOSAL_LOCATIONS',
  });
};

export const addProposalBoxInLocation = (
  locationIdx,
  productGroups,
  boxName,
  changeProduct,
  versionPrice,
  oneTimeCharge,
  installation,
) => dispatch => {
  dispatch({
    type: 'ADD_PROPOSAL_BOX_IN_LOCATION',
    locationIdx,
    productGroups,
    boxName,
    changeProduct,
    versionPrice,
    oneTimeCharge,
    installation,
  });
  // toast.success('Add new box success!', { toastId: 'ADD_PROPOSAL_BOX_IN_LOCATION' });
};

export const addProposalBoxToast = () => dispatch => {
  dispatch({
    type: 'ADD_PROPOSAL_BOX_TOAST',
  });
  toast.success('Add proposal box success!', { toastId: 'ADD_PROPOSAL_BOX_TOAST' });
};

export const copyProposalBoxInLocation = (locationIdx, duplicateBox) => dispatch => {
  dispatch({
    type: 'COPY_PROPOSAL_BOX_IN_LOCATION',
    locationIdx,
    duplicateBox,
  });
  toast.success('Copy proposal box success!', { toastId: 'COPY_PROPOSAL_BOX_IN_LOCATION' });
};

export const boxProductQuantityChangeInLocation = (
  locationIdx,
  boxIndex,
  productGroupName,
  productName,
  quantity,
  selected,
  count,
) => dispatch => {
  dispatch({
    type: 'PROPOSAL_BOX_PRODUCT_QUANTITY_CHANGE_IN_LOCATION',
    locationIdx,
    boxIndex,
    productGroupName,
    productName,
    quantity,
    selected,
    count,
  });
};

export const onOneTimeQuantityChange = (
  locationIdx,
  boxIndex,
  productGroupName,
  productName,
  quantity,
  selected,
  count,
) => dispatch => {
  dispatch({
    type: 'PROPOSAL_ONETIME_QUANTITY_CHANGE_IN_LOCATION',
    locationIdx,
    boxIndex,
    productGroupName,
    productName,
    quantity,
    selected,
    count,
  });
};

export const onInstallationQuantityChange = (
  locationIdx,
  boxIndex,
  productGroupName,
  productName,
  quantity,
  selected,
  count,
) => dispatch => {
  dispatch({
    type: 'PROPOSAL_INSTALLATION_QUANTITY_CHANGE_IN_LOCATION',
    locationIdx,
    boxIndex,
    productGroupName,
    productName,
    quantity,
    selected,
    count,
  });
};

export const boxProductPriceChange = (productGroupName, productName, key, price) => dispatch => {
  dispatch({
    type: 'PROPOSAL_BOX_PRODUCT_PRICE_CHANGE_IN_LOCATION',
    productGroupName,
    productName,
    key,
    price,
  });
  dispatch({
    type: 'CHANGE_PRICE_PRODUCT_GROUPS',
    productGroupName,
    productName,
    key,
    price,
  });
};

export const onOneTimePriceChange = (productGroupName, productName, key, price) => dispatch => {
  dispatch({
    type: 'PROPOSAL_ONE_TIME_PRICE_CHANGE_IN_LOCATION',
    productGroupName,
    productName,
    key,
    price,
  });
  dispatch({
    type: 'CHANGE_PRICE_ONE_TIME_CHARGE',
    productGroupName,
    productName,
    key,
    price,
  });
};

export const onInstallationPriceChange = (
  productGroupName,
  productName,
  key,
  price,
) => dispatch => {
  dispatch({
    type: 'PROPOSAL_INSTALLATION_PRICE_CHANGE_IN_LOCATION',
    productGroupName,
    productName,
    key,
    price,
  });
  dispatch({
    type: 'CHANGE_PRICE_INSTALLATION_CHARGE',
    productGroupName,
    productName,
    key,
    price,
  });
};

export const removeProposalBoxInLocation = (locationIdx, boxIndex) => dispatch => {
  dispatch({
    type: 'REMOVE_PROPOSAL_BOX_IN_LOCATION',
    locationIdx,
    boxIndex,
  });
};

export const setProposalDisplayMode = mode => dispatch => {
  dispatch({
    type: 'SET_PROPOSAL_DISPLAY_MODE',
    mode,
  });
};

export const saveProposal = (token, userId, proposal) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SAVE_PROPOSAL',
    proposal,
    userId,
  });
  try {
    const savedProposal = await api.proposals.saveProposal(userId, proposal);
    dispatch({
      type: 'SAVE_PROPOSAL_SUCCESS',
      proposal: savedProposal,
    });
    toast.success('New proposal saved!', { toastId: 'SAVE_PROPOSAL_SUCCESS' });
    return savedProposal;
  } catch (error) {
    dispatch({
      type: 'SAVE_PROPOSAL_ERROR',
      error,
    });
    toast.error(error.message || 'Error saving proposal item', { toastId: 'SAVE_PROPOSAL_ERROR' });
  }
};

export const uploadSignedContract = (token, id, file) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPLOAD_SIGNED_CONTRACT',
  });
  try {
    const uploadedContract = await api.proposals.uploadSignedContract(id, file);
    dispatch({
      type: 'UPLOAD_SIGNED_CONTRACT_SUCCESS',
      uploadedContract,
    });
    toast.success('Signed Contract Uploaded', { toastId: 'UPLOAD_SIGNED_CONTRACT_SUCCESS' });
    return uploadedContract;
  } catch (error) {
    dispatch({
      type: 'UPLOAD_SIGNED_CONTRACT_ERROR',
      error,
    });
    toast.error(error.message || 'Error saving contract', {
      toastId: 'UPLOAD_SIGNED_CONTRACT_ERROR',
    });
  }
};

export const updateProposal = (token, proposalId, proposal) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_PROPOSAL',
    proposal,
    proposalId,
  });
  try {
    const updatedProposal = await api.proposals.updateProposal(proposalId, proposal);
    dispatch({
      type: 'UPDATE_PROPOSAL_SUCCESS',
      proposal: updatedProposal,
    });
    toast.success('Proposal updated!', { toastId: 'UPDATE_PROPOSAL_SUCCESS' });
    return updatedProposal;
  } catch (error) {
    dispatch({
      type: 'UPDATE_PROPOSAL_ERROR',
      error,
    });
    toast.error(error.message || 'Error update proposal item', {
      toastId: 'UPDATE_PROPOSAL_ERROR',
    });
  }
};

export const deleteAttachment = (token, id, path) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_ATTACHMENT',
  });
  try {
    const deleteAttachment = await api.proposals.deleteAttachment(id, path);
    dispatch({
      type: 'DELETE_ATTACHMENT_SUCCESS',
      proposal: deleteAttachment,
    });
    toast.success('Attachment Deleted!', { toastId: 'DELETE_ATTACHMENT_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_ATTACHMENT_ERROR',
      error,
    });
    toast.error(error.message || 'Error deleting attachment', {
      toastId: 'DELETE_ATTACHMENT_ERROR',
    });
  }
};

/**
 *
 * @param boxIndex {number} index of the box in the proposal
 * @param productGroup {ProductGroup} - The product groups object for the proposal
 * @returns {Function} action dispatcher
 */

export const updateProposalProductGroup = (locationIdx, boxIndex, productGroups) => dispatch => {
  dispatch({
    type: 'UPDATE_PROPOSAL_BOX_PRODUCT_GROUPS_IN_LOCATION',
    locationIdx,
    boxIndex,
    productGroups,
  });
};

export const updateProposalOneTimeCharge = (locationIdx, boxIndex, oneTimeCharge) => dispatch => {
  dispatch({
    type: 'UPDATE_PROPOSAL_ONE_TIME_CHARGE_IN_LOCATION',
    locationIdx,
    boxIndex,
    oneTimeCharge,
  });
};

export const updateProposalInstallationCharge = (
  locationIdx,
  boxIndex,
  installation,
) => dispatch => {
  dispatch({
    type: 'UPDATE_PROPOSAL_INSTALLATION_CHARGE_IN_LOCATION',
    locationIdx,
    boxIndex,
    installation,
  });
};

export const addBoxProposalProduct = (boxIndex, groupName, product) => dispatch => {
  dispatch({
    type: 'ADD_PROPOSAL_BOX_PRODUCT',
    boxIndex,
    groupName,
    product,
  });
};

export const removeBoxProposalProduct = (boxIndex, groupID, product) => dispatch => {
  dispatch({
    type: 'REMOVE_PROPOSAL_BOX_PRODUCT',
    boxIndex,
    groupID,
    product,
  });
};

export const setStatusProposal = isNewProposal => dispatch => {
  dispatch({
    type: 'SET_STATUS_PROPOSAL',
    isNewProposal,
  });
};

export const setVerizonProductGroups = isVerizonProducts => dispatch => {
  dispatch({
    type: 'SET_VERIZON_PRODUCT_GROUPS',
    isVerizonProducts,
  });
};

export const addProposalLocation = payload => dispatch => {
  dispatch({
    type: 'ADD_PROPOSAL_LOCATION',
    payload,
  });
};

export const removeProposalLocation = locationIdx => dispatch => {
  dispatch({
    type: 'REMOVE_PROPOSAL_LOCATION',
    locationIdx,
  });
  dispatch({
    type: 'DELETE_LOCATION_CONFIRM',
  });
};

export const proposalLocationFieldUpdate = (locationIdx, name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_LOCATION_FIELD_UPDATE',
    locationIdx,
    name,
    value,
  });
};

export const proposalBoxFieldUpdate = (locationIdx, boxIndex, name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_BOX_FIELD_UPDATE',
    locationIdx,
    boxIndex,
    name,
    value,
  });
};

export const proposalOneTimeFieldUpdate = (locationIdx, boxIndex, name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_ONETIME_FIELD_UPDATE',
    locationIdx,
    boxIndex,
    name,
    value,
  });
};

export const proposalInstallationFieldUpdate = (locationIdx, boxIndex, name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_INSTALLATION_FIELD_UPDATE',
    locationIdx,
    boxIndex,
    name,
    value,
  });
};

export const getProductGroups = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PRODUCT_GROUPS',
  });
  try {
    const productGroups = await api.proposals.getProductGroups(companyId);
    dispatch({
      type: 'GET_PRODUCT_GROUPS_SUCCESS',
      productGroups,
    });
    return productGroups;
  } catch (error) {
    dispatch({
      type: 'GET_PRODUCT_GROUPS_ERROR',
      error,
    });
  }
};

export const getProductGroupsVerizon = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PRODUCT_GROUPS_VERIZON',
  });
  try {
    const productGroups = await api.proposals.getProductGroupsVerizon();
    dispatch({
      type: 'GET_PRODUCT_GROUPS_VERIZON_SUCCESS',
      productGroups,
    });
    return productGroups;
  } catch (error) {
    dispatch({
      type: 'GET_PRODUCT_GROUPS_VERIZON_ERROR',
      error,
    });
  }
};

export const getProductGroupsChange = (token, companyId, versionPrice) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PRODUCT_GROUPS_CHANGE',
  });
  try {
    const productGroups = versionPrice
      ? await api.proposals.getProductGroupsVerizon()
      : await api.proposals.getProductGroups(companyId);
    dispatch({
      type: 'GET_PRODUCT_GROUPS_CHANGE_SUCCESS',
      productGroups,
    });
    return productGroups;
  } catch (error) {
    dispatch({
      type: 'GET_PRODUCT_GROUPS_CHANGE_ERROR',
      error,
    });
  }
};

export const getOneTimeChargeGroups = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ONE_TIME_CHARGE_GROUP',
  });
  try {
    const oneTimeCharge = await api.proposals.getOneTimeChargeGroups(companyId);
    dispatch({
      type: 'GET_ONE_TIME_CHARGE_GROUP_SUCCESS',
      oneTimeCharge,
    });
    return oneTimeCharge;
  } catch (error) {
    dispatch({
      type: 'GET_ONE_TIME_CHARGE_GROUP_ERROR',
      error,
    });
  }
};

export const getInstallationGroups = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_INSTALLATION',
  });
  try {
    const installation = await api.proposals.getInstallationGroups(companyId);
    dispatch({
      type: 'GET_INSTALLATION_SUCCESS',
      installation,
    });
    return installation;
  } catch (error) {
    dispatch({
      type: 'GET_INSTALLATION_ERROR',
      error,
    });
  }
};

export const setProductGroups = productGroups => dispatch => {
  dispatch({
    type: 'SET_PRODUCT_GROUPS',
    productGroups,
  });
};

export const setOneTimeCharge = oneTimeCharge => dispatch => {
  dispatch({
    type: 'SET_ONETIME_CHARGE',
    oneTimeCharge,
  });
};

export const setInstallation = installation => dispatch => {
  dispatch({
    type: 'SET_INSTALLATION',
    installation,
  });
};

export const showDeleteLocationModal = (locationIdx, locationName) => dispatch => {
  dispatch({
    type: 'DELETE_LOCATION_SHOW',
    locationIdx,
    locationName,
  });
};

export const cancelDeleteLocation = () => dispatch => {
  dispatch({
    type: 'DELETE_LOCATION_CANCEL',
  });
};

export const copyLocation = locationIdx => dispatch => {
  dispatch({
    type: 'COPY_LOCATION',
    locationIdx,
  });
};

export const changeProductDescription = (
  locationIdx,
  boxIndex,
  productGroupName,
  productName,
  value,
) => dispatch => {
  dispatch({
    type: 'CHANGE_PRODUCT_DESCRIPTION',
    locationIdx,
    boxIndex,
    productGroupName,
    productName,
    value,
  });
};

export const showDownloadDocsModal = () => dispatch => {
  dispatch({
    type: 'DOWLOAD_DOCS_SHOW',
  });
};

export const cancelDownloadDocsModal = () => dispatch => {
  dispatch({
    type: 'DOWNLOAD_DOCS_CANCEL',
  });
};

export const validateFirstTab = () => dispatch => {
  dispatch({
    type: 'VALIDATE_FIRST_TAB',
  });
  toast.error('You need to fill in all the fields', { toastId: 'UPDATE_PROPOSAL_ERROR' });
};

export const validateSecondTab = () => dispatch => {
  dispatch({
    type: 'VALIDATE_SECOND_TAB',
  });
  toast.error('You need to add 4G LTE and 4G Network Monitoring in your box', {
    toastId: 'UPDATE_PROPOSAL_ERROR',
  });
};

export const getStateCountry = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_STATE_COUNTRY',
  });
  try {
    const stateCountry = await api.proposals.getStateCountry();
    dispatch({
      type: 'GET_STATE_COUNTRY_SUCCESS',
      stateCountry,
    });
    return stateCountry;
  } catch (error) {
    dispatch({
      type: 'GET_STATE_COUNTRY_ERROR',
      error,
    });
  }
};

export const getStateCodes = token => async dispatch => {
  const api = new Api(token);

  try {
    const stateCodes = await api.proposals.getStateCodesApi();
    dispatch({
      type: 'GET_STATE_CODES_SUCCESS',
      payload: stateCodes,
    });
  } catch (error) {
    dispatch({
      type: 'GET_STATE_CODES_ERROR',
      error,
    });
  }
};

export const getCityOfState = (token, state) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_CITY_OF_STATE',
  });
  try {
    const cityOfState = await api.proposals.getCityOfState(state);
    dispatch({
      type: 'GET_CITY_OF_STATE_SUCCESS',
      cityOfState,
    });
    return cityOfState;
  } catch (error) {
    dispatch({
      type: 'GET_CITY_OF_STATE_ERROR',
      error,
    });
  }
};

export const uploadAttachments = (token, id, files) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPLOAD_ATTACHMENTS',
  });
  try {
    const uploadAttachments = await api.proposals.uploadAttachments(id, files);
    dispatch({
      type: 'UPLOAD_ATTACHMENTS_SUCCESS',
      uploadAttachments,
    });
    return uploadAttachments;
  } catch (error) {
    dispatch({
      type: 'UPLOAD_ATTACHMENTS_ERROR',
      error,
    });
  }
};

export const onSendEmail = (token, id, email) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SEND_EMAIL',
  });
  try {
    const onSendEmail = await api.proposals.onSendEmail(id, email);
    dispatch({
      type: 'SEND_EMAIL_SUCCESS',
      onSendEmail,
    });
    return onSendEmail;
  } catch (error) {
    dispatch({
      type: 'SEND_EMAIL_ERROR',
      error,
    });
  }
};
